// src/api/index.ts
import request from '../utils/request';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus';
import { removeAllSession } from '../utils/session';
import {showLoading,hideLoading } from '@/utils/loading';
import { isEmpty } from '@/utils/app-utils';
import  wsManager  from './WebSocketManager';
import { userData } from '@/store/userData';
import pako from 'pako';
export const useResponseStore = response;
export const fetchData = () => { 
    return request({
        url: './mock/table.json',
        method: 'get'
    });
};

export const fetchUserData = () => {
    return request({
        url: './mock/user.json',
        method: 'get'
    });
};

export const fetchRoleData = () => {
    return request({
        url: './mock/role.json',
        method: 'get'
    });
};

let urls = ["user/login"];


const setAuthorization = (url :string) :any=> {
   let loginKey = ""
   if( !urls.includes(url)){
        loginKey = sessionStorage.getItem('loginKey');
   }
   return loginKey;
};

const setCurrentOrgId = (): string | number => {
    const orgId = sessionStorage.getItem('currentOrgId');
    if( orgId == "0" ){
        return "-1";
    }
    return isEmpty(orgId) ? "-1" : orgId;
};

/**
 * 封装请求方法
 */
export const ajax = async (options) => {
    const { 
        url, 
        method = 'GET', 
        data = {}, 
        success, 
        error, 
        loading = { open: true, text: "" }, 
        aotuErrMsg = true, 
        isLoading = true,
        dataFormat = 'json', // 'json' | 'form'
        compress = false // 新增参数：是否压缩，默认为 false
    } = options;
    
    loading.open = isLoading;
    if (loading.open) {
        showLoading(loading);
    }

    const headers = {
        Authorization: setAuthorization(url),
        'currentOrgId': setCurrentOrgId(),
        'Custom-Header': 'CustomValue'
    };

    try {
        let response;
        const requestUrl = '/api/' + url;

        // 数据压缩逻辑
        let requestData = data;
        if (compress && method.toUpperCase() === 'POST') {
            if (dataFormat === 'json') {
                // JSON 数据压缩
                const jsonString = JSON.stringify(data);
                const compressedData = pako.gzip(jsonString, { to: 'string' });
                requestData = compressedData;
                headers['Content-Encoding'] = 'gzip'; // 设置请求头
            } else if (dataFormat === 'form') {
                // 表单数据压缩（暂不支持，可扩展）
                throw new Error('表单数据压缩（暂不支持，可扩展）');
            }
        }

        if (method.toUpperCase() === 'GET') {
            response = await axios.get(requestUrl, {
                headers: headers
            });
        } else if (method.toUpperCase() === 'POST') {
            if (dataFormat === 'form') {
                const formData = new FormData();
                Object.keys(data).forEach(key => {
                    if (data[key] instanceof File || data[key] instanceof Blob) {
                        formData.append(key, data[key]);
                    } else {
                        formData.append(key, String(data[key]));
                    }
                });

                response = await axios.post(requestUrl, formData, {
                    headers: {
                        ...headers
                    }
                });
            } else {
                response = await axios.post(requestUrl, requestData, {
                    headers: {
                        ...headers,
                        'Content-Type': 'application/json'
                    }
                });
            }
        } else {
            throw new Error(`Unsupported HTTP method: ${method}`);
        }

        // 响应数据解压逻辑
        let responseData = response.data;
        // const contentEncoding = response.headers['content-encoding1'];
        // if (contentEncoding === 'gzip') {
        //     try {
        //         const decompressedData = pako.inflate(responseData, { to: 'string' });
        //         responseData = JSON.parse(decompressedData);
        //     } catch (inflateError) {
        //         console.error('解压响应数据失败:', inflateError);
        //         throw new Error('解压响应数据失败');
        //     }
        // }

        if (success) {
            if (loading.open) {
                hideLoading();
            }
            errorMsg(responseData, success);
        }
    } catch (err) {
        if (loading.open) {
            hideLoading();
        }
        if (error) {
            error(err); // 传递错误对象
        }
    }
};

/**
 * 封装 SSE 流式请求方法
 */
export const ajaxAiSSE = async (options) => {
  // 添加 signal 参数支持
  const { 
    url, 
    method = 'POST', 
    data = {}, 
    onMessage, onComplete, onError, 
    loading = {open:true,text:"" }, 
    dataFormat = 'json', // 新增：'json' | 'form'
    signal,
    isLoading = true // 新增参数
   } = options;
  
  loading.open = isLoading; // 设置 loading.open 为 isLoading 的值
  
  if(loading.open){
    showLoading(loading);
  }
  
  try {
    // 构建请求URL
    const requestUrl = `/ai/${url}`;
    
    // 创建请求配置
    const config: RequestInit = {
      method: method.toUpperCase(),
      headers: {
        'Authorization': setAuthorization(url) || '',
        'currentOrgId': String(setCurrentOrgId()),
        'Custom-Header': 'CustomValue'
      },
      // 添加 signal 到配置中
      signal: signal
    };
    
    // 如果是POST请求，添加请求体
    if (method.toUpperCase() === 'POST' && data) {
      if (dataFormat === 'form') {
        // 表单格式
        const formData = new FormData();
        Object.keys(data).forEach(key => {
          if (data[key] instanceof File || data[key] instanceof Blob) {
            // 处理文件类型数据
            formData.append(key, data[key]);
          } else {
            // 处理普通数据
            formData.append(key, String(data[key]));
          }
        });
        config.body = formData;
        // 使用 FormData 时，不设置 Content-Type，让浏览器自动设置
        delete config.headers['Content-Type'];
      } else {
        // JSON 格式（默认）
        config.body = JSON.stringify(data);
        config.headers['Content-Type'] = 'application/json';
      }
    } else if (!config.headers['Content-Type']) {
      // 默认设置为 JSON 格式
      config.headers['Content-Type'] = 'application/json';
    }
    
    // 发起 fetch 请求
    const response = await fetch(requestUrl, config);
    
    if(loading.open){
      hideLoading();
    }
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    if (!response.body) {
      throw new Error('ReadableStream not supported in this browser.');
    }
    
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    
    // 读取数据流
    while (true) {
      // 检查是否已中止
      if (signal && signal.aborted) {
        reader.cancel();
        break;
      }
      
      const { done, value } = await reader.read();
      
      if (done) {
        break;
      }
      
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      
      // 保留不完整的行
      buffer = lines.pop() || '';
      
      for (const line of lines) {
        if (line.startsWith('data: ')) {
          try {
            const jsonData = JSON.parse(line.slice(6));
            // 处理不同类型的消息
            if (jsonData.type === 'end') {
              if (onComplete) onComplete(jsonData);
            } else {
              if (onMessage) onMessage(jsonData);
            }
          } catch (parseError) {
            console.error('Error parsing SSE data:', parseError);
          }
        }
      }
    }
    
    // 处理剩余缓冲区中的数据
    if (buffer.startsWith('data: ')) {
      try {
        const jsonData = JSON.parse(buffer.slice(6));
        if (jsonData.type === 'end') {
          if (onComplete) onComplete(jsonData);
        } else {
          if (onMessage) onMessage(jsonData);
        }
      } catch (parseError) {
        console.error('Error parsing SSE data:', parseError);
      }
    }
    
  } catch (err) {
    if(loading.open){
      hideLoading();
    }
    
    // 区分中止错误
    if (err.name === 'AbortError') {
      onError(err);
      return;
    }
    
    console.error('SSE 请求失败:', err);
    if (onError) {
      onError(err);
    }
  }
};

/**
 * 封装 WebSocket 流式请求方法（单例模式）
 */
export const webSocket = {
    /**
     * 连接 WebSocket
     */
    connect: (url: string, options?: {
        onOpen?: () => void;
        onMessage?: (data: any) => void;
        onClose?: () => void;
        onError?: (error: any) => void;
        reconnectCount?: number;
        reconnectInterval?: number;
        heartbeatInterval?: number;
    }) => {
        // 添加授权头信息
        const loginKey = setAuthorization(url);
        const currentOrgId = setCurrentOrgId();
        
        // 构建完整 URL（带参数）
        const wsUrl = `${url}?loginKey=${loginKey}&currentOrgId=${currentOrgId}`;
        
        wsManager.connect(wsUrl, options);
    },

    /**
     * 发送消息
     */
    send: (data: any) => {
        wsManager.send(data);
    },

    /**
     * 关闭连接
     */
    close: () => {
        wsManager.close();
    },

    /**
     * 获取连接状态
     */
    getReadyState: () => {
        return wsManager.getReadyState();
    }
};

/**
 * 文件上传
 * @param code 
 */
export const uploadFile = async (options) => {
    const { url, file, data = {}, success, error, loading = { open: false, text: "" },  } = options;
    try {
        if(loading.open){
            showLoading(loading);
        }
        // 创建一个 FormData 对象
        const formData = new FormData();
        formData.append('file', file);

        if (data) {
            Object.keys(data).forEach(key => {
                formData.append(key, data[key]);
            });
        }

        // 发送 POST 请求
        const response = await axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: setAuthorization(url),
                'currentOrgId': setCurrentOrgId(),
            }
        });

        // 调用成功回调（如果提供）
        if (success) {
            if(loading.open){
                hideLoading();
            }
           errorMsg(response.data, success);
        }
    } catch (err) {
        if(loading.open){
            hideLoading();
        }
        if (error) {
            error(err); // 传递错误对象
        }
    }
};

/**
 * 文件下载
 * @param code 
 */
export const downloadFile = async (options) => {
    const { 
        url, 
        method = 'GET',
        loading = {open:true,text:"" }, 
        params = {}, 
        data = {}, 
        fileName = 'downloaded-file', 
        success, 
        error,
        dataFormat = 'json' // 新增参数：'json' | 'form'
    } = options;
    
    if( loading.open ){
        showLoading(loading);
    }
    
    // 添加与 ajax 方法相同的请求头
    const headers = {
        Authorization: setAuthorization(url),
        'currentOrgId': setCurrentOrgId(),
        'Custom-Header': 'CustomValue'
    };
    
    try {
        let response;
        const requestUrl = url; // 添加与 ajax 方法相同的 URL 构造
        
        // 直接发起请求，不再预检查，避免重复请求
        if (method.toUpperCase() === 'POST') {
            if (dataFormat === 'form') {
                const formData = new FormData();
                Object.keys(data).forEach(key => {
                    if (data[key] instanceof File || data[key] instanceof Blob) {
                        formData.append(key, data[key]);
                    } else {
                        formData.append(key, String(data[key]));
                    }
                });
                
                response = await axios.post(requestUrl, formData, {
                    headers: headers,
                    responseType: 'blob'
                });
            } else {
                response = await axios.post(requestUrl, data, {
                    headers: {
                        ...headers,
                        'Content-Type': 'application/json'
                    },
                    responseType: 'blob'
                });
            }
        } else {
            response = await axios.get(requestUrl, {
                headers: headers,
                params,
                responseType: 'blob'
            });
        }

        // 检查响应类型来判断是文件还是错误信息
        const contentDisposition = response.headers['content-disposition'];
        const contentType = response.headers['content-type'];

        // 如果响应头表明是文件下载，则执行下载
        if (contentDisposition && contentDisposition.includes('attachment')) {
            // 是文件下载
            const blob = new Blob([response.data]);
            const downloadUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);

            if( loading.open ){
                hideLoading();
            }
            
        } else {
            // 没有文件下载头，尝试解析响应为 JSON
            try {
                // 将 blob 转换为文本，然后解析为 JSON
                const text = await response.data.text();
                const jsonData = JSON.parse(text);
                
                if( loading.open ){
                    hideLoading();
                }
                
                if (success) {
                    errorMsg(jsonData, success);
                }
            } catch (e) {
                // 如果无法解析为 JSON，说明是其他类型的响应
                if( loading.open ){
                    hideLoading();
                }
                
                if (success) {
                    // 创建一个通用错误信息
                    errorMsg({
                        code: -1,
                        msg: '未知错误',
                        data: null,
                        dataList: null,
                        success: false,
                        total: 0
                    }, success);
                }
            }
        }

    } catch (err) {
        if( loading.open ){
            hideLoading();
        }
        if (error) {
            error(err);
        }
    }
};

/**
 * 文件导出方法
 * @param options 导出配置选项
 */
export const exportFile = async (options) => {
    const { url, data = {}, fileName = 'export-file.xlsx', success, error, loading = { open: true, text: "导出中..." } } = options;
    
    if (loading.open) {
        showLoading(loading);
    }
    
    const headers = {
        Authorization: setAuthorization(url),
        'Content-Type': 'application/json',
        'Custom-Header': 'CustomValue'
    };
    
    try {
        // 发送 POST 请求并接收 blob 类型响应
        const response = await axios.post("/api/" + url, data, {
            headers: headers,
            responseType: 'blob' // 关键：设置响应类型为 blob
        });

        if (loading.open) {
            hideLoading();
        }

        // 创建下载链接并触发下载
        const blob = new Blob([response.data]);
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);

        // 调用成功回调
        if (success) {
            errorMsg(response.data, success);
        }
    } catch (err) {
        if (loading.open) {
            hideLoading();
        }
        
        if (error) {
            error(err);
        }
    }
};

/**
 *  base64图片上传
 * @param options 
 */
export const uploadImgBase64 = async (options) => {
    const { url,  base64, data = {}, success, error } = options; // 确保 data 默认值为一个空对象
    try {
        let formData = new FormData();
        const blob = base64ToBlob(base64);
        formData.append('file', blob); 
       
        // 添加额外的表单数据
        if (data) {
            Object.keys(data).forEach(key => {
                formData.append(key, data[key]);
            });
        }

        // 发送 POST 请求
        const response = await axios.post('/api/'+url, formData, {
            headers: {
                Authorization:  setAuthorization(url),
                'Content-Type': 'multipart/form-data' // 确保使用 multipart/form-data
            }
        });

        // 调用成功回调（如果提供）
        if (success) {
            errorMsg(response.data, success);
        }
    } catch (err) {
        if (error) {
            error(err); // 传递错误对象
        }
    }
};

/**
 *  blob图片上传
 * @param options 
 */
export const uploadImgBlob = async (options) => {
    const { url,  file, data = {}, success, error, loading = {open:true,text:"" } } = options; // 确保 data 默认值为一个空对象
    try {
        if( loading.open ){
            showLoading(loading);
        }
        let formData = new FormData();
        formData.append('file', file); 
       
        // 添加额外的表单数据
        if (data) {
            Object.keys(data).forEach(key => {
                formData.append(key, data[key]);
            });
        }

        // 发送 POST 请求
        const response = await axios.post('/api/'+url, formData, {
            headers: {
                Authorization:  setAuthorization(url),
                'Content-Type': 'multipart/form-data' // 确保使用 multipart/form-data
            }
        });

        // 调用成功回调（如果提供）
        if (success) {
            if( loading.open ){
                hideLoading();
            }
            errorMsg(response.data, success);
        }
    } catch (err) {
        if( loading.open ){
            hideLoading();
        }
        if (error) {
            error(err); // 传递错误对象
        }
    }
};

/**
 * 错误反馈处理（后端返回的错误信息）
 * @param code 
 */
const errorMsg = (data: any, success?: Function) => {
    let code = data.code;
    let msg = data.msg;
    const useData = userData();
    switch (code) { 
        case -202:
            ElMessage.error(msg);
            removeAllSession();
            useAuthStore().setLoginKey(null);
            useData.removeAll();
            break;
        case -201:
            ElMessage.error(msg);
            removeAllSession();
            useAuthStore().setLoginKey(null);
            useData.removeAll();
            break;
        case -203:
            ElMessage.error(msg);
            removeAllSession();
            useAuthStore().setLoginKey(null);
            useData.removeAll();
            break;
        case -301:
            success(data);
            showVipRightEndMsg(data);
            break;
        case -302:
            success(data);
            showVipRightEndMsg(data);
            break;
        case -303:
            success(data);
            showVipRightEndMsg(data);
            break;
        default:
            if (success) {
                success(data);
            } else {
                // 可以添加默认错误处理逻辑
                ElMessage.error(msg || '非法错误！');
            }
            break;
    }
}

/**
 * 错误反馈处理(浏览器请求失败)
 * @param code 
 */
const responseMsg = (data: any) => {
    let code = data.code;
    let msg = data.msg;
    const useData = userData();
    switch (code) {
        case -202:
            ElMessage.error(msg);
            removeAllSession();
            useData.removeAll();
            break;

        default:
            
            break;
    }
}

/**
 * 将 Base64 字符串转换为 Blob 对象
 * @param base64String Base64 编码的字符串
 * @returns Blob 对象
 */
const base64ToBlob = (base64String: string): Blob => {
    // 提取 MIME 类型
    const parts = base64String.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
};

/**
 * 权益用完或不足的窗口
 */
const showVipRightEndMsg = (data: any) => {
  ElMessageBox.confirm(data.msg, '提示', {
    confirmButtonText: '去充值',
    cancelButtonText: '关闭'
  })
    .then(() => {
        console.log("点击去充值");
        response().setShowTopUp(true);
        response().setCode(data.code);
    })
    .catch(() => {
      
    });
};



